module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Edition Open.40974683.png";